<template>
  <div v-if="user">
    <modalWindow v-model="showModel" @ok="createSubmit()" @cancel="cancel()" @closed="onClose()" title="Editácia užívateľa" :cancelText="'Zrušiť'" :okText="'Uložiť'">
      <form>
        <text-field field-id="username"
                    label="Prihlasovacie meno"
                    placeholder="Zadaj prihlasovacie meno"
                    v-model="user.username"
                    :maxlength="100"
                    validation="required|min:5|max:100"></text-field>

        <text-field v-if="!editMode"
                    field-id="password"
                    label="Heslo"
                    type="password"
                    placeholder="Zadaj heslo"
                    v-model.trim="user.password"
                    :maxlength="20"
                    validation="required|min:5|max:20"></text-field>

        <text-field field-id="firstname"
                    label="Meno"
                    placeholder="Zadaj meno"
                    v-model.trim="user.firstname"
                    :maxlength="100"
                    validation="required|min:3|max:100"></text-field>

        <text-field field-id="surname"
                    label="Priezvisko"
                    placeholder="Zadaj priezvisko"
                    v-model.trim="user.surname"
                    :maxlength="100"
                    validation="required|min:3|max:100"></text-field>

        <text-field field-id="email"
                    label="E-mail"
                    placeholder="Zadaj e-mail"
                    v-model.trim="user.email"
                    :maxlength="30"
                    validation="min:6|max:30|email"></text-field>


        <text-field field-id="phoneNumber"
                    label="Telefónne číslo"
                    placeholder="Zadaj telefónne číslo"
                    v-model.trim="user.phoneNumber"
                    :maxlength="30"
                    validation="min:9|max:30"></text-field>

        <select-field field-id="roles"
                      label="Užívateľské role"
                      :multiple="true"
                      :options="roles"
                      v-model="selectedRoles"></select-field>
      </form>
    </modalWindow>
  </div>
</template>

<script>
  import { roles } from 'codelist/';
  import modal from 'vue-strap/src/Modal';
  import _ from 'lodash';
  import validationMixin from 'components/validationMixin';
  import textField from 'components/form/textField';
  import selectField from 'components/form/selectField';
  import notificationService from 'services/notificationService';

  export default {
    components: {modalWindow: modal, selectField, textField},
    mixins: [validationMixin],
    data: () => ({
      selectedRoles: [],
      roles: roles,
      user: null
    }),
    computed: {
      editMode() {
        return this.user && this.user.id
      }
    },
    props: {
      showModel: {
        type: Boolean,
        default: false
      },
      model: {
        type: Object
      }
    },
    methods: {
      createSubmit() {
        this.protect();
        this.$validator.validateAll().then((res) => {
          if (res) {
            let operation;
            if (this.user.id) {
              operation = 'update';
            } else {
              operation = 'create';
            }
            const user = _.cloneDeep(this.user);
            this.$store.dispatch('user/' + operation, user).then((result) => {
              if (result) {
                notificationService.success('user.edit.success');
                this.$emit('close');
              } else {
                this.unprotect();
              }
            }).catch(this.unprotect);
          } else {
            this.unprotect();
          }
        }).catch(this.unprotect);
      },
      cancel() {
        this.$emit('close');
      },
      onClose() {
        this.selectedRoles = [];
        this.unprotect();
        this.$nextTick(() => {
          this.errors.clear();
        });
      }
    },
    watch: {
      model: function (model) {
        if (model) {
          this.user = _.cloneDeep(model);
          this.selectedRoles = _.filter(roles, (item) => model.roles.includes(item.value));
        }
      },
      selectedRoles: function (selectedRoles) {
        this.user.roles = _.map(selectedRoles, 'value');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/userCreateModal.vue